
import React, { useContext, useEffect, useState } from 'react'
import { FiSearch } from 'react-icons/fi'
import { Formik, Form } from 'formik'

import { Button, Calendar, Select, Textbox } from '~/components/Form'
import masks from '~/util/masks'
import { Container } from './styles'
import { api, authHeaders } from '~/services/api'
import { GlobalContext } from '~/contexts/GlobalContext'

export default function ({ handlePesquisar, validadoresIds }) {
	const { user } = useContext(GlobalContext)

	const [assuntos, setAssuntos] = useState(null)

	async function loadAssuntos() {
		const response = await api.get('visita_diretoria/assunto', authHeaders())

		setAssuntos(response.map(item => ({
			label: item.descricao,
			value: item.id
		})))
	}

	useEffect(() => {
		loadAssuntos()
	}, [])

	const eValidador = validadoresIds?.includes(user?.pessoa.id)

	return (
		<Formik
			onSubmit={handlePesquisar}
			initialValues={{
				inicio: '',
				fim: '',
				data_conclusao: '',
				data_validacao: '',
				crm: '',
				nome: '',
				assunto: null
			}}
		>
			{({ setFieldValue }) => (
				<Form>
					<Container>
						<Calendar
							name="inicio"
							yearNavigator
							label="Data inicial"
							yearRange={`2024:${new Date().getFullYear()}`}
						/>

						<Calendar
							name="fim"
							yearNavigator
							label="Data final"
							yearRange={`2024:${new Date().getFullYear()}`}
						/>

						{eValidador && (
							<>
								<Calendar
									name="data_conclusao"
									yearNavigator
									label="Data exata da atividade"
									yearRange={`2024:${new Date().getFullYear()}`}
								/>

								<Calendar
									name="data_validacao"
									yearNavigator
									label="Data de validação"
									yearRange={`2024:${new Date().getFullYear()}`}
								/>

								<Textbox
									mask={masks.numero}
									name="crm"
									label="CRM"
								/>

								<Textbox
									name="nome"
									label="Nome"
								/>

								<Select
									name="assunto"
									label="Assunto"
									options={assuntos}
									onChange={(selected, meta) => {
										setFieldValue(meta.name, selected)
									}}
								/>
							</>
						)}

						<Button type="submit" className="transparent self-end w-fit self-end md:col-span-2 lg:col-span-4 md:justify-self-end">
							Pesquisar
							<FiSearch size={16} />
						</Button>
					</Container>
				</Form>
			)}
		</Formik>
	)
}
